import { useLayoutEffect } from 'react';
import history from '../utils/browserHistory';
import { clearAuthStorage } from './authStorage';
import { customerLoginPath } from './customerPortal';

export const useDefineHeaderToken = (axios) => {
  useLayoutEffect(() => {
    const interceptorId = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const isAuthRequest = error.config?.url?.includes('/login') || error.config?.url?.includes('/session');
        if (!isAuthRequest && error.response?.status === 401) {
          clearAuthStorage();
          // Already on a login page: re-pushing would drop ?next= (OAuth consent return).
          if (/^\/(customer\/)?login\b/.test(window.location.pathname)) return Promise.reject(error);
          history.push(window.location.pathname.startsWith('/customer/')?customerLoginPath():'/login');
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptorId);
    };
  }, [axios]);
};
